module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lBMDAN/tc-custom/9781452126913.jpg?1705026024085",
      "alt": "This image is the cover for the book Training People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Training People\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This guide to choosing the right human for you and getting them to behave will have you howling with laughter—and rethinking obedience training.")]), _c('br'), _c('br'), _vm._v("For centuries, dogs have known that they, not humans, run the show. But not all dogs know how to get the best from their people. Finally, from the leading expert in the field comes a straightforward, easy-to-use manual that’s written for dogs by a dog. "), _c('br'), _c('br'), _vm._v("This indispensable reference provides foolproof advice on obtaining everything a dog deserves, from the best food and exercise to grooming and chauffeur services. Here are all the tools a dog needs for selecting, training, and living with a well-behaved human.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tess of Helena\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tess of Helena is a nationally renowned Certified Trainer of Humans whose revolutionary techniques have transformed the field.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0